// `appVersion` selects which API version Grape routes to: "1" -> v1, "2" -> v2.
// Defaults to "1" so existing callers keep hitting v1 unchanged.
const headers = (appVersion = "1") => ({
  headers: {
    "Device-Type": "web",
    "App-Version": String(appVersion)
  }
})

export default headers
